import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import OrderComponent from '../components/Order/Order'
import OrdersData from '../components/Order/OrdersData'
import Header from '../components/Headers/Header'
import { useQuery, gql } from '@apollo/client'
import { getOrdersByRestaurant } from '../apollo'
import useGlobalStyles from '../utils/globalStyles'
import { Box, Container, Modal, Typography } from '@mui/material'
import { modalOverlay, modalCard } from '../utils/modalStyles'

const GET_ORDERS = gql`
  ${getOrdersByRestaurant}
`

const SEARCH_DEBOUNCE_MS = 400

const Orders = () => {
  const [detailsModal, setDetailModal] = useState(false)
  const [order, setOrder] = useState(null)
  const [page, setPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [searchQuery, setSearchQuery] = useState('')
  const [search, setSearch] = useState('')
  const restaurantId = localStorage.getItem('restaurantId')

  // Searching hits the server (order ID or voucher code), so wait for typing to
  // settle and go back to the first page whenever the term changes.
  useEffect(() => {
    const timer = setTimeout(() => {
      setSearch(searchQuery.trim())
      setPage(1)
    }, SEARCH_DEBOUNCE_MS)
    return () => clearTimeout(timer)
  }, [searchQuery])

  const {
    data,
    error: errorQuery,
    loading: loadingQuery,
    subscribeToMore
  } = useQuery(GET_ORDERS, {
    variables: {
      restaurant: restaurantId,
      page: page - 1,
      rows: rowsPerPage,
      search
    }
  })
  const toggleModal = order => {
    setOrder(order)
    setDetailModal(!detailsModal)
  }

  const globalClasses = useGlobalStyles()
  return (
    <>
      <Header />
      {/* Page content */}
      <Container className={globalClasses.flex} fluid>
        {errorQuery && (
          <Typography sx={{ color: 'error.main', mb: 2 }}>
            {errorQuery.message}
          </Typography>
        )}
        <OrdersData
          orders={data && data.ordersByRestId}
          toggleModal={toggleModal}
          subscribeToMore={subscribeToMore}
          loading={loadingQuery}
          selected={order}
          updateSelected={setOrder}
          page={setPage}
          rows={setRowsPerPage}
          currentPage={page}
          search={search}
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
        />
        <Modal
          open={detailsModal}
          onClose={() => {
            toggleModal(null)
          }}
          sx={modalOverlay}>
          <Box sx={modalCard('lg')}>
            <OrderComponent order={order} onClose={() => toggleModal(null)} />
          </Box>
        </Modal>
      </Container>
    </>
  )
}
export default withTranslation()(Orders)
